export default {
  name: 'ed-link-viewer',
  props: ['section'],
 methods: {
    goToUrl() {
      window.open(this.section.text, '_blank');
    }
  },

  computed: {
    url() {
      return this.section.text ? this.section.text : null;
    },
    baseUrl(){
      return this.url.split('/')[2];
    },
    isWebView(): boolean {
      return this.$store.state.AppStore.webview;
    },
  }
};